var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12C22.5 11.8011 22.421 11.6104 22.2803 11.4697C22.1397 11.329 21.9489 11.25 21.75 11.25L4.0605 11.25L8.781 6.53103C8.92183 6.3902 9.00094 6.19919 9.00094 6.00003C9.00094 5.80087 8.92183 5.60986 8.781 5.46903C8.64017 5.3282 8.44916 5.24908 8.25 5.24908C8.05083 5.24908 7.85983 5.3282 7.719 5.46903L1.719 11.469C1.64915 11.5387 1.59374 11.6215 1.55593 11.7126C1.51812 11.8037 1.49866 11.9014 1.49866 12C1.49866 12.0987 1.51812 12.1964 1.55593 12.2875C1.59374 12.3786 1.64915 12.4614 1.719 12.531L7.719 18.531C7.78873 18.6008 7.87151 18.6561 7.96262 18.6938C8.05373 18.7316 8.15138 18.751 8.25 18.751C8.44916 18.751 8.64017 18.6719 8.781 18.531C8.92183 18.3902 9.00095 18.1992 9.00095 18C9.00095 17.8009 8.92183 17.6099 8.781 17.469L4.0605 12.75L21.75 12.75C21.9489 12.75 22.1397 12.671 22.2803 12.5304C22.421 12.3897 22.5 12.1989 22.5 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.310f5672fa98606376f5cfe0ea7d9d3a.svg";
export { ForwardRef as ReactComponent };